/* Gift guide 2026 — behaviour
   Carousel arrows + counter, size reveal on "Add to cart", AJAX add (theme quick cart),
   SEO accordion open on desktop. Loads once even if several sections include it. */
(function () {
  'use strict';
  if (window.__GG_INIT__) return;
  window.__GG_INIT__ = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mqDesktop = window.matchMedia('(min-width: 750px)');

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gg-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function closePickers(except) {
    document.querySelectorAll('.gg-card.is-picking').forEach(function (c) {
      if (c !== except) c.classList.remove('is-picking');
    });
  }

  function openQuickCart() {
    try {
      var wrapper = document.querySelector('.quick-cart__wrapper');
      if (wrapper) {
        var cs = getComputedStyle(wrapper);
        if (cs.display !== 'none' && cs.visibility !== 'hidden') return;
      }
      var icon = document.querySelector('.icon-button-header-shopping-cart, [data-quick-cart-toggle]');
      if (icon) (icon.closest('a,button') || icon).click();
    } catch (e) {}
  }

  function markAdded(card, label) {
    var btn = card.querySelector('.gg-card__atc');
    card.classList.remove('is-picking');
    if (!btn) return;
    var orig = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', orig);
    btn.textContent = 'Added' + (label ? ' · ' + label : '') + ' ✓';
    btn.classList.add('is-added');
    setTimeout(function () {
      btn.textContent = orig;
      btn.classList.remove('is-added');
    }, 2200);
  }

  function addVariant(card, variantId, price, label) {
    /* Preferred: the theme's own quick add (adds + refreshes + opens the quick cart) */
    if (typeof window.quickAddToCart === 'function') {
      try {
        window.quickAddToCart(variantId, price || 0);
        markAdded(card, label);
        toast('Added to your bag');
        setTimeout(openQuickCart, 500);
        return;
      } catch (err) { if (window.console) console.warn('[gift-guide] quickAddToCart failed', err); }
    }
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag'); return d; }); })
      .then(function () {
        markAdded(card, label);
        toast('Added to your bag');
        try { if (typeof window.handleCartUpdate === 'function') window.handleCartUpdate(); } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        setTimeout(openQuickCart, 350);
      })
      .catch(function (err) { toast(err.message || 'Could not add — try again'); });
  }

  document.addEventListener('click', function (e) {
    /* ---- Add to cart: reveal sizes (or add straight away for one-size products) ---- */
    var atc = e.target.closest('.gg-card__atc');
    if (atc && atc.tagName === 'BUTTON') {
      e.preventDefault();
      if (atc.disabled) return;
      var card = atc.closest('.gg-card');
      var single = atc.getAttribute('data-variant-id');
      if (single) { addVariant(card, parseInt(single, 10), parseFloat(atc.getAttribute('data-price')), ''); return; }
      closePickers(card);
      card.classList.add('is-picking');
      var first = card.querySelector('.gg-size:not([disabled])');
      if (first) first.focus({ preventScroll: true });
      return;
    }

    /* ---- size chosen: add it ---- */
    var size = e.target.closest('.gg-size');
    if (size) {
      e.preventDefault();
      if (size.disabled) return;
      addVariant(size.closest('.gg-card'), parseInt(size.getAttribute('data-variant-id'), 10), parseFloat(size.getAttribute('data-price')), size.textContent.trim());
      return;
    }

    /* ---- carousel arrows ---- */
    var navBtn = e.target.closest('.gg-row__btn');
    if (navBtn) {
      var row = navBtn.closest('.gg-row');
      var track = row && row.querySelector('.gg-track');
      if (track) {
        var c = track.querySelector('.gg-card');
        var step = c ? c.getBoundingClientRect().width + 20 : 260;
        track.scrollBy({ left: navBtn.hasAttribute('data-prev') ? -step : step, behavior: 'smooth' });
      }
      return;
    }

    /* ---- click outside an open size picker closes it ---- */
    if (!e.target.closest('.gg-card.is-picking')) closePickers(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePickers(null);
  });

  /* ---------- carousel state: arrows + "01 — 05" counter ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function updateRow(row) {
    var track = row.querySelector('.gg-track');
    if (!track) return;
    var cards = track.querySelectorAll('.gg-card');
    var nav = row.querySelector('.gg-row__nav');
    var overflow = track.scrollWidth > track.clientWidth + 4;
    track.classList.toggle('is-overflowing', overflow);
    if (nav) nav.style.visibility = overflow ? '' : 'hidden';
    var prev = row.querySelector('[data-prev]');
    var next = row.querySelector('[data-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    var cur = row.querySelector('[data-count-current]');
    var tot = row.querySelector('[data-count-total]');
    if (cur && tot && cards.length) {
      var w = cards[0].getBoundingClientRect().width + 20;
      var idx = Math.min(cards.length, Math.round(track.scrollLeft / w) + 1);
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) idx = cards.length;
      cur.textContent = pad(idx);
      tot.textContent = pad(cards.length);
    }
  }
  function initRows() {
    document.querySelectorAll('.gg-row').forEach(function (row) {
      var track = row.querySelector('.gg-track');
      if (track && !track.__ggBound) {
        track.__ggBound = true;
        track.addEventListener('scroll', function () { updateRow(row); }, { passive: true });
      }
      updateRow(row);
    });
  }

  /* ---------- SEO guide: open on desktop, collapsed on mobile ---------- */
  function syncSeo() {
    document.querySelectorAll('.gg-seo__item').forEach(function (d) {
      if (mqDesktop.matches) d.setAttribute('open', '');
      else if (!d.__ggTouched) d.removeAttribute('open');
    });
  }
  document.addEventListener('toggle', function (e) {
    if (e.target.classList && e.target.classList.contains('gg-seo__item')) e.target.__ggTouched = true;
  }, true);

  var rT;
  window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () { initRows(); syncSeo(); }, 150); });
  function init() { initRows(); syncSeo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', initRows);
  document.addEventListener('shopify:section:load', init);
})();
